import FieldInputRenderer from '../fields/FieldInputRenderer';

const WhoWeWorkWithClientEditor = ({ index, fields, fieldValues, onFieldChange }) => {
  const titleField = fields.find((field) => field.key.endsWith('-title'));
  const clientTitle = titleField ? fieldValues[titleField.id] : `Client ${index}`;

  return (
    <article className="rounded-md border border-[#e4d9c8] bg-[#faf8f4] p-4">
      <div className="mb-4 border-b border-[#e4d9c8] pb-3">
        <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-[#6b635c]">
          Client {index}
        </p>
        <p className="mt-1 text-sm font-semibold text-[#130705]">{clientTitle || 'Untitled client'}</p>
      </div>

      <div className="grid gap-3">
        {fields.map((field) => (
          <div key={field.id}>
            <label
              htmlFor={`field-${field.id}`}
              className="mb-1.5 block text-[12px] font-medium text-[#6b635c]"
            >
              {field.label}
            </label>
            <FieldInputRenderer
              field={field}
              value={fieldValues[field.id] || ''}
              onChange={(value) => onFieldChange(field.id, value)}
            />
          </div>
        ))}
      </div>
    </article>
  );
};

export default WhoWeWorkWithClientEditor;
